// extracted by mini-css-extract-plugin
export default {"title":"ibKX2LnunB","tall":"bs-dulodF9"};